import React, { useEffect, useState } from 'react';
import api from '../../api';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';

const PasswordResetForm = () => {
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const [isTimerActive, setIsTimerActive] = useState(false);
    const [timerSeconds, setTimerSeconds] = useState(60);

    const location = useLocation();
    const navigate = useNavigate();
    const { username } = location.state || {};

    useEffect(() => {
        const savedTimerState = localStorage.getItem('resetTimerState');
        if (savedTimerState) {
            const { isTimerActive: savedIsTimerActive, timerSeconds: savedTimerSeconds } = JSON.parse(savedTimerState);
            setIsTimerActive(savedIsTimerActive);
            setTimerSeconds(savedTimerSeconds);
        } else {
            setIsTimerActive(true);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('resetTimerState', JSON.stringify({ isTimerActive, timerSeconds }));

        let intervalId;

        if (isTimerActive && timerSeconds > 0) {
            intervalId = setInterval(() => {
                setTimerSeconds(prev => prev - 1);
            }, 1000);
        }

        if (timerSeconds === 0) {
            setIsTimerActive(false);
            setTimerSeconds(60);
        }

        return () => clearInterval(intervalId);
    }, [isTimerActive, timerSeconds]);

    if (!username) {
        return <div className="alert alert-danger mt-5 text-center">نام کاربری پیدا نشد.</div>;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!code || code.length < 4) {
            toast.error('کد وارد شده معتبر نیست');
            return;
        }
        if (password !== confirmPassword) {
            toast.error('رمز عبور با تکرار آن مطابقت ندارد');
            return;
        }

        setIsLoading(true);

        api.post('/reset-password', { username, token: code, password })
            .then((res) => {
                toast.success(res.data.message || 'رمز با موفقیت تغییر یافت');
                localStorage.removeItem('resetTimerState');
                setTimeout(() => navigate('/login'), 1500);
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'خطا در تغییر رمز');
            })
            .finally(() => setIsLoading(false));
    };

    const resendCode = () => {
        if (isTimerActive) return;

        setIsLoading(true);
        api.post('/forgot-password', { username })
            .then(res => {
                toast.success('کد بازیابی مجدداً ارسال شد');
                setIsTimerActive(true);
            })
            .catch(() => {
                toast.error('ارسال مجدد کد با مشکل مواجه شد');
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <div className="content-wrapper login-bg">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer position="top-center" autoClose={2000} rtl theme="light" />
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card rounded-4 border-3 border-dark mb-4">
                            <h5 className="card-header bg-dark text-white text-center">بازیابی رمز عبور</h5>
                            <div className="card-body">

                                {/* پیام بالای فرم */}
                                <div className="mb-4 p-3 rounded border bg-light   flex justify-content-between align-items-center">
                                    <p className="mb-0" style={{ fontSize: '0.95rem' }}>
                                        پیامک حاوی لینک به شماره‌ای که مربوط به این {username} کدملی  است ارسال شده  .
                                    </p>
                                    <button
                                        className="btn btn-link p-0"
                                        onClick={() => navigate('/forgot-password')}
                                        style={{ fontSize: '0.9rem' }}
                                    >
                                        تغییر کد ملی
                                    </button>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <label htmlFor="code" className="mb-1">کد ارسال شده</label>
                                    <input
                                        type="text"
                                        className="form-control text-center mb-3"
                                        id="code"
                                        name="code"
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                        placeholder="کد ۶ رقمی"
                                    />

                                    <label htmlFor="password">رمز عبور جدید</label>
                                    <input
                                        type="password"
                                        className="form-control mb-3"
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />

                                    <label htmlFor="confirmPassword">تکرار رمز عبور</label>
                                    <input
                                        type="password"
                                        className="form-control mb-4"
                                        id="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <button type="submit" className="btn btn-warning" disabled={isLoading}>
                                            {isLoading ? 'در حال ارسال...' : 'ثبت رمز جدید'}
                                        </button>

                                        <button
                                            type="button"
                                            onClick={resendCode}
                                            disabled={isTimerActive || isLoading}
                                            className="btn btn-outline-secondary"
                                        >
                                            {isTimerActive ? `ارسال مجدد کد بعد از ${timerSeconds} ثانیه` : 'ارسال مجدد کد'}
                                        </button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordResetForm;
